<ifc-status-label [status]="statusLabels" [value]="status"></ifc-status-label>
